module.exports = __webpack_public_path__ + "img/Login-3.4baf7cd2.png";